module.exports = __webpack_public_path__ + "img/features04-03.726a6ca.png";